import React, { useEffect, useState } from "react";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import CheckoutForm from "../Payments/CheckoutForm";
import BaseModal from "./BaseModal";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);

const appearance = {
    theme: "flat",
};

const PaymentModal = ({
    isVisible,
    setIsVisible,
    clientSecret,
    subscription,
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stripeOptions, setStripeOptions] = useState(null);

    useEffect(() => {
        if (clientSecret) {
            setStripeOptions({
                clientSecret,
                appearance,
            });
        }
    }, [clientSecret]);

    return (
        <>
            <BaseModal
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                isSubmitting={isSubmitting}
                title="Payment Details"
                isSmall={true}
                hideFooter={true}
            >
                <div className="flex flex-wrap stripe-wrapper m-auto">
                    <div className="stripe-card mb-12 px-4 bg-white-200 rounded-xl p-5">
                        {stripeOptions && (
                            <Elements
                                options={stripeOptions}
                                stripe={stripePromise}
                            >
                                <CheckoutForm
                                    isSubmitting={isSubmitting}
                                    setIsSubmitting={setIsSubmitting}
                                    clientSecret={clientSecret}
                                    subscriptionId={subscription?.id}
                                />
                            </Elements>
                        )}
                    </div>
                </div>
            </BaseModal>
        </>
    );
};

export default PaymentModal;
